import React, { useState,createRef,useRef } from 'react'
import { useReactToPrint } from "react-to-print";
import {FaDownload} from "react-icons/fa"
// import "./Style.css"
import './Preview.css';



export default function Preview(props) {
  
    // console.log("data of props",props)
    const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
 
    
  return (
    <div className='pdf'>
    <div>
         <button className='down' onClick={handlePrint}>Download pdf<span><FaDownload/></span>
         </button>
    </div>
    <div  ref={componentRef}>
       
        
    
           
            <div className ="resume">
   <div className="resume_left">
     <div className="resume_profile">
       <img src="https://media.istockphoto.com/id/618066222/photo/camera-capturing-a-forest.jpg?b=1&s=170667a&w=0&k=20&c=ZvaijnZ8Gbl6UjYHsCqNGEcekAWIVeVNKaVKZ5CtuNI=" alt="profile_pic"/>
     </div>
     <div className="resume_content">
       <div className="resume_item resume_info">
         {/* <div className="title">
           <p className="bold">{props.values.name}</p>
           <p className="regular">Designer</p>
         </div> */}

         <div className="title">
           <p className="bold">Contacts</p>
         </div>

        
         <ul>
           <li>
             <div className="data">
             <p className="semi-bold" style={{fontWeight:'bold',color:'white'}} ><i class="fa-solid fa-phone"></i> Phone</p>
              <p className='phone'>{props.values.phone}</p>
             </div>
           </li>
           <li>
             
             <div className="data">
             <p className="semi-bold" style={{fontWeight:'bold',color:'white'}}><i class="fa-solid fa-envelope"></i> Email </p>
             <p className = 'emaill' >{props.values.email} </p>
             </div>
           </li> 
          
           <li>
             
             <div className="data">
               <p className="semi-bold" style={{fontWeight:'bold',color:'white'}}><i class="fa-brands fa-linkedin"></i> Linkedin</p>
               <p className='phone'>{props.values.linkedin}</p>
             </div>
           </li>
           <li>
             
             <div className="data">
               <p className="semi-bold" style={{fontWeight:'bold',color:'white'}}><i class="fa-brands fa-github"></i> GitHub</p>
               <p className='phone'>{props.values.github}</p>
             </div>
            </li>
           </ul>
         </div>
            
          <div className="resume_item resume_skills">
         <div className="title">
           <p className="bold">skill's</p>
         </div>
         <ul>
           <li>
             <div className="skill_name">
             {props.values.skills}
             </div>
           </li>
            
         </ul>
        </div>


        <div className="resume_item resume_social">
         <div className="title">
           <p className="bold" style={{color:'white'}}>Extra-Curriculars</p>
         </div>

        <p>
        <ul className='extras'>
         <li><p style={{color:'#b1eaff'}}><a style={{fontWeight:'bold',color:'white'}}>
         Languages: </a><br/>{props.values.extra_1}</p>
         </li>
         <li><p style={{color:'#b1eaff'}}><a style={{fontWeight:'bold',color:'white'}}>
         Sports: </a><br/>{props.values.extra_2}</p>
         </li>
         <li><p style={{color:'#b1eaff'}}><a style={{fontWeight:'bold',color:'white'}}>
         Others: </a><br/>
         {props.values.extra_3}<br/>{props.values.extra_4}<br/>{props.values.extra_5}</p>
         </li>
       </ul>
       </p>
             
         </div>
         </div>
         </div>

       <div className="resume_right">
        <div className="resume_item resume_about">
        <div className="title">
           <b className="bold1" >{props.values.name}<br/><br/></b>
         </div>
        </div>

       <div className="resume_item resume_work">
        <div className="title">
           <p className="bold">Work Experience</p>
         </div>
         
         <ul className='workdetails'>
         <li>
          <div className="date" >{props.values.exp1_org}</div> 
            <div className="info">
              <p className="semi-bold">{props.values.exp1_pos},({props.values.exp1_dur})</p> 
              <p className='workdesc'>{props.values.exp1_desc}</p>
                </div>
            </li>

            <li>
              <div className="date" >{props.values.exp2_org}</div>
              <div className="info">
                <p className="semi-bold">{props.values.exp2_pos},({props.values.exp2_dur})</p> 
                <p className='workdesc'>{props.values.exp2_desc}</p>
             </div>
            </li>
            
            <li>
              <div className="date" ><b>PROJECTS</b></div>
              
              <div className="info">
                  <p className="semi-bold"><p className='proj'>{props.values.proj1_title}</p></p>
                  <p className='workdesc'>({props.values.proj1_link})</p>
                  <p className='workdesc'>{props.values.proj1_desc}</p>
              </div>
              <div className="info">
                  <p className="semi-bold"><p className='proj'>{props.values.proj2_title}</p></p>
                  <p className='workdesc'>({props.values.proj2_link})</p>
                  <p className='workdesc'>{props.values.proj2_desc}</p>
              </div>
            </li>
         </ul>
        </div>

        <div className="resume_item resume_education">
      <div className="title">
           <p className="bold">Education</p>
         </div>
         <ul>
            <li>
                <div className="date">{props.values.edu1_school}</div> 
                <div className="info">
                     <p className="semi-bold"><p className='workdesc'>({props.values.edu1_qualification},
                     {props.values.edu1_year})</p></p>
                     <p className='workdesc'>{props.values.edu1_desc}</p>
                </div>
            </li>
            <li>
              <div className="date">{props.values.edu2_school}</div>
              <div className="info">
                     <p className="semi-bold"><p className='workdesc'>({props.values.edu2_qualification},
                     {props.values.edu2_year})</p></p>
                    <p className='workdesc'>{props.values.edu2_desc}</p>
              </div>
            </li>
        </ul>
      </div>
      
        </div>
         </div>     
          </div>
        </div>
       
  )
}
